// extracted by mini-css-extract-plugin
export default {"burger":"Burger_burger__YCEU7","open":"Burger_open__D-Wse"};